import type { RouteRecordRaw } from "vue-router";

export const foldersRoutes: RouteRecordRaw[] = [
  {
    path: "/folders",
    name: "folders-index",
    component: () => import("./FolderListPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // Static routes must come before dynamic :id
  {
    path: "/folders/discarded",
    name: "folders-discarded-items",
    component: () => import("./discarded/FolderDiscardedPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/folders/:id",
    name: "folders-show",
    component: () => import("./[id]/FolderDetailPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
